import { GetSapConnectionUseCase, TestSapConnectionUseCase, UpsertSapConnectionUseCase } from '@/data/use-cases/sap-connection-use-cases.js';
import type { GetSapConnection, TestSapConnection, UpsertSapConnection } from '@/domain/use-cases/sap-connection.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { makeSapConnectionRepository } from '@/main/factories/repositories/sap-connection-repository.js';

export type SapConnectionUseCases = {
    get: GetSapConnection;
    upsert: UpsertSapConnection;
    test: TestSapConnection;
};

export const makeSapConnectionUseCases = (httpClient: FetchHttpClient): SapConnectionUseCases => {
    const repository = makeSapConnectionRepository(httpClient);
    return {
        get: new GetSapConnectionUseCase(repository),
        upsert: new UpsertSapConnectionUseCase(repository),
        test: new TestSapConnectionUseCase(repository)
    };
};
